<template>
    <div id="app">
        <router-view/>
        <loading-view v-bind:show="show"></loading-view>
    </div>
</template>

<script>
    import Loading from '@/components/Loading';

    export default {
        name: 'App',
        components: {
            'loading-view': Loading
        },
        data() {
            return {
                show: false,
                meta: {},
                sessionTimer: null,
                isForceLoggingOut: false,
                isCheckingSession: false
            };
        },
        methods: {
            handleForceLogout(customMessage) {
                if (this.isForceLoggingOut) {
                    return;
                }
                this.isForceLoggingOut = true;
                window.__isForceLoggingOut = true;

                if (this.sessionTimer) {
                    clearInterval(this.sessionTimer);
                    this.sessionTimer = null;
                }

                var message = customMessage || 'Akun Anda telah login di perangkat lain. Sesi pada perangkat ini otomatis dikeluarkan.';

                try {
                    sessionStorage.setItem('sessionKickMessage', message);
                    localStorage.removeItem('vue-authenticate.vueauth_token');
                    localStorage.removeItem('supervisorLocked');
                } catch (e) {}

                this.$store.commit('authenticate', { isAuthenticated: false });
                this.$store.commit('profile', {});

                window.location.replace('/');
            },
            checkActiveSession() {
                if (this.isForceLoggingOut || this.isCheckingSession) {
                    return;
                }

                if (!this.$store.getters.isAuthenticated) {
                    return;
                }

                var profile = this.$store.getters.profile || {};
                if (profile.isAdmin || profile.isEmployee) {
                    return;
                }

                this.isCheckingSession = true;
                this.axios.get(process.env.API_URL + '/user/profile', {
                    meta: {
                        loading: false,
                        throwError: false
                    }
                }).then(response => {
                    this.isCheckingSession = false;
                    if (response && response.response && response.response.status === 401) {
                        var resData = response.response.data || {};
                        this.handleForceLogout(resData.message);
                    }
                }).catch(error => {
                    this.isCheckingSession = false;
                    if (error && error.response && error.response.status === 401) {
                        var errData = error.response.data || {};
                        this.handleForceLogout(errData.message);
                    }
                });
            },
            handleVisibilityOrFocus() {
                if (!document.hidden) {
                    this.checkActiveSession();
                }
            }
        },
        beforeCreate() {
            this.axios.interceptors.request.use(
                    request => {
                        this.meta = request.meta || {};
                        if (typeof this.meta.loading === typeof undefined || this.meta.loading) {
                            this.show = true;
                        }
                        return request;
                    }
            );
            this.axios.interceptors.response.use(
                    response => {
                        // Pakai meta milik request ini sendiri. this.meta bisa sudah ditimpa request lain yang
                        // dimulai belakangan (misalnya cek sesi berkala dengan loading: false), sehingga overlay
                        // loading tidak pernah ditutup dan menghalangi siswa mengerjakan soal.
                        var reqMeta = (response && response.config) ? (response.config.meta || {}) : this.meta;
                        if (!reqMeta || typeof reqMeta.loading === typeof undefined || reqMeta.loading) {
                            this.show = false;
                        }
                        return response;
                    },
                    error => {
                        var reqMeta = (error && error.config) ? (error.config.meta || {}) : this.meta;
                        if (!reqMeta || typeof reqMeta.loading === typeof undefined || reqMeta.loading) {
                            this.show = false;
                        }

                        if (error && error.response && error.response.status === 401) {
                            var reqUrl = (error.config && error.config.url) ? error.config.url : '';
                            var isLoginRequest = reqUrl.indexOf('/auth/login') > -1;
                            var isLogoutRequest = reqUrl.indexOf('/auth/logout') > -1;
                            var resData = error.response.data || {};
                            var hasToken = !!(this.$store.getters.isAuthenticated || localStorage.getItem('vue-authenticate.vueauth_token'));

                            if (!isLoginRequest && !isLogoutRequest && (hasToken || resData.sessionKicked)) {
                                this.handleForceLogout(resData.message || error.response.statusText);
                                return error;
                            }
                        }

                        var throwError = typeof this.meta.throwError !== typeof undefined ? this.meta.throwError : true;
                        if (reqMeta && typeof reqMeta.throwError !== typeof undefined) {
                            throwError = reqMeta.throwError;
                        }

                        if (throwError && error && error.response) {
                            switch (error.response.status) {
                                case 401:
                                    var warnMsg = (error.response.data && error.response.data.message) ? error.response.data.message : error.response.statusText;
                                    this.$toastr('warning', warnMsg, 'Warning');
                                    this.$router.replace({name: 'index'});
                                    break;
                                default:
                                    this.$router.push({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
                                    break;
                            }
                        }
                        return error;
                    }
            );
            this.$store.dispatch('setProfile', {requestOptions: {meta: {throwError: false}}});
        },
        mounted() {
            if (document.title === '') {
                document.title = process.env.APP_NAME;
            }

            try {
                var kickMessage = sessionStorage.getItem('sessionKickMessage');
                if (kickMessage) {
                    sessionStorage.removeItem('sessionKickMessage');
                    setTimeout(() => {
                        this.$toastr('warning', kickMessage, 'Peringatan Sesi');
                    }, 300);
                }
            } catch (e) {}

            // Pantau sesi aktif siswa secara berkala agar perangkat lama otomatis logout saat akun login di perangkat baru
            this.sessionTimer = setInterval(() => {
                this.checkActiveSession();
            }, 10000);

            window.addEventListener('focus', this.handleVisibilityOrFocus);
            document.addEventListener('visibilitychange', this.handleVisibilityOrFocus);
        },
        beforeDestroy() {
            if (this.sessionTimer) {
                clearInterval(this.sessionTimer);
                this.sessionTimer = null;
            }
            window.removeEventListener('focus', this.handleVisibilityOrFocus);
            document.removeEventListener('visibilitychange', this.handleVisibilityOrFocus);
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue